import type { HostedEvent } from "@hobbyshopify/backend-client";
import { Rx, RxList } from "subtree.js/core";
import { idleLoad, type LoadStatus } from "../../core/primitives/load-status";
import type { ShareTarget } from "../../core/primitives/share-links";

/** The shows the shop hosts: still to come, then over. */
export class EventsState {
  readonly status = new Rx<LoadStatus>(idleLoad);
  /** Whether HobbyScan has switched hosting on for the shop. */
  readonly canHost = new Rx(false);
  /** Whether the signed-in member may write: a Manager or an Owner. */
  readonly mayManage = new Rx(false);
  readonly upcoming = new RxList<HostedEvent>();
  readonly past = new RxList<HostedEvent>();
  /** Each published show to come's page on hobbyshop.ai, by show id. */
  readonly shares = new Rx<ReadonlyMap<string, ShareTarget>>(new Map());
}

export abstract class EventsActions {
  abstract create(): void;
  abstract retry(): void;
  abstract open(eventId: string): void;
}
